import {connect} from 'react-redux';
import {setQcReportsStatusesAction} from './Redux/QCReportsStatusesActions';
import {QCReportsStatusesState} from './QCReportsStatusesTypes';
import QCReportsStatusesContainer from './QCReportsStatusesContainer';

export type State = {
    qcTools: {
        qcReportsStatuses: QCReportsStatusesState
    }
};

export const mapState = (state: State): QCReportsStatusesState => {
    const {qcTools} = state;
    const {qcReportsStatuses} = qcTools;
    
    return qcReportsStatuses;
};

const mapDispatch = {
    setQcReportsStatuses: setQcReportsStatusesAction,
};

export default connect(mapState, mapDispatch)(QCReportsStatusesContainer);
